import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  Label,
  SubmitBtn,
  SideCancelBtn,
  Wrapper,
  ScrollableContent,
  ActionSection,
  FieldWrappers,
  ModalHeader,
} from "../Styles/InputStyles";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import DropZone from "../Notice/Dropzone";
import { MdClose } from "react-icons/md";

const documentSchema = Yup.object().shape({
  title: Yup.string()
    .required("Title is required")
    .min(3, "Title must be at least 3 characters"),
  file: Yup.mixed().required("File is required"),
});

const PropertyDocumentUploadModal = ({
  handleClose,
  uploadDocMutate,
  isDocLoading,
  currentPath,
  id,
  folders,
}) => {
  const initialDocumentValues = {
    title: "",
    file: null,
  };

  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => setHeight(window.innerHeight);

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDocumentSubmit = (values) => {
    const formData = new FormData();

    formData.append(
      "folderId",
      currentPath.length > 0 ? currentPath[currentPath.length - 1].id : "",
    );

    formData.append("title", values.title);
    formData.append("file", values.file[0]);

    uploadDocMutate(formData);
  };

  return (
    <Container
      style={{
        height: `${height}px`,
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <ModalHeader>
        <Title>Upload Document</Title>

        <button onClick={handleClose}>
          <MdClose color="white" size={24} />
        </button>
      </ModalHeader>
      <div className="px-6 h-full flex flex-col justify-between">
        <Formik
          initialValues={initialDocumentValues}
          onSubmit={handleDocumentSubmit}
          validationSchema={documentSchema}
        >
          {({ values, setFieldValue, errors, touched, setFieldTouched }) => (
            <Form className="flex flex-col h-full">
              <ScrollableContent className="flex-1">
                <Wrapper>
                  <InputGroup>
                    <Label htmlFor="file">Upload Document *</Label>
                    <FieldWrapper>
                      <Field name="file">
                        {(props) => (
                          // <DropZone
                          //   fields={props.field}
                          //   setFieldValue={props.form.setFieldValue}
                          //   componentFor="expense"
                          //   acceptedFiles="image/*,application/pdf"
                          //   File={
                          //     props.field.value ? [props.field.value] : null
                          //   }
                          // />
                          <DropZone
                            fields={props.field}
                            setFieldValue={(field, value) => {
                              props.form.setFieldValue(field, value);

                              if (value && value.length > 0) {
                                const file = value[0];

                                // Remove extension
                                const fileName = file.name.replace(
                                  /\.[^/.]+$/,
                                  "",
                                );

                                // Only set title if user hasn't typed one yet
                                if (!props.form.values.title) {
                                  props.form.setFieldValue("title", fileName);
                                }
                              }
                            }}
                            componentFor="doc-valut"
                            acceptedFiles="image/*,application/pdf"
                            File={
                              props.field.value ? [props.field.value] : null
                            }
                          />
                        )}
                      </Field>
                    </FieldWrapper>
                    {errors.file && touched.file && (
                      <ErrorMessage>{errors.file}</ErrorMessage>
                    )}
                  </InputGroup>

                  <InputGroup>
                    <Label htmlFor="title">Document Title *</Label>
                    <FieldWrappers>
                      <Field
                        type="text"
                        name="title"
                        id="title"
                        autoComplete="off"
                        // required
                        placeholder="Enter document title (e.g., Electricity Bill, NOC Letter, etc.)"
                      />
                    </FieldWrappers>
                    {errors.title && touched.title && (
                      <ErrorMessage>{errors.title}</ErrorMessage>
                    )}
                  </InputGroup>
                </Wrapper>
              </ScrollableContent>
              <ActionSection>
                <SideCancelBtn
                  type="button"
                  onClick={handleClose}
                  disabled={isDocLoading}
                >
                  Cancel
                </SideCancelBtn>
                <SubmitBtn type="submit" disabled={isDocLoading}>
                  {isDocLoading ? "Uploading..." : "Upload"}
                </SubmitBtn>
              </ActionSection>
            </Form>
          )}
        </Formik>
      </div>
    </Container>
  );
};

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const ErrorMessage = tw.div`text-red-500 text-xs mt-1`;
const FieldWrapper = tw.div`w-full`;
const Title = tw.h1`text-white text-lg font-medium`;

export default PropertyDocumentUploadModal;
